//RecordButton.js
import React from 'react';
import { Button, Tooltip, Typography } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';
import { useTheme } from '@mui/material/styles';


// const bgcolor = 'primary.main';
// const bghover = 'primary.dark';
// const bgcolor = "#2d4a7a";
// const bghover = "#102a55";

const RecordButton = ({ recording, startRecording, stopRecording, disabled, language, sx }) => {
    const tooltipTitle = `Record yourself speaking in ${language}.
If the input text area is not empty, your speech will be compared to it.
Otherwise, your speech, as understood, will be copied there.`;

    const theme = useTheme();

    return (
        <Tooltip title={tooltipTitle} arrow>
            <Button
                onClick={recording ? stopRecording : startRecording}
                disabled={disabled}
                variant="contained"
                color={recording ? "error" : "primary"} // Red for stop, primary color for start
                startIcon={recording ? <StopIcon /> : <MicIcon />}
                sx={[{
                    textTransform: 'none', // Maintain original casing for the text
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '8px 16px',
                    fontSize: 16,
                    // backgroundColor: recording ? '#ff4d4d' : bgcolor,
                    // backgroundColor: recording ? '#ff4d4d' : 'primary.main',
                    backgroundColor: recording ? '#ff4d4d' : theme.customColors.bgcolor,
                    '&:hover': {
                        backgroundColor: recording ? '#ff6666' : theme.customColors.bghover,
                    } }, sx]
                }
            >
                <Typography>
                    {/* {recording ? 'Stop Recording' : 'Start Recording'} */}
                    {recording ? 'STOP' : 'RECORD'}
                </Typography>
            </Button>
        </Tooltip>
    );
};

export default RecordButton;
